<p-dialog [(visible)]="usuarioDialog" (onHide)="closeDialogUser()" [style]="{'top': '4vh'}"
          [header]="estadoAccionUsuario?'Registrar ' + this.headerLabel :'Editar ' + this.headerLabel"
          [modal]="true" class="p-fluid responsive-dialog-usuario" [draggable]="false" [resizable]="true">
    <ng-template pTemplate="content">
        <form [formGroup]="formRegistro">
            <p-accordion [activeIndex]="0" [selectOnFocus]="true"
                         class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
                    <div class="mb-3 text-base">
                            <span class="flex align-items-center gap-2 w-full">
                                <span class="font-bold white-space-nowrap">
                                     Información general <i
                                    class="pi pi-tag ml-auto mr-2"></i>
                                </span>
                            </span>
                    </div>
                    <div class="field">
                        <label for="tipoPersona">Tipo de persona <small style="color:red"><b>
                            *</b></small></label>
                        <p-dropdown id="tipoPersona"
                                    showError
                                    pAutoFocus
                                    [options]="tiposPersona"
                                    styleClass="p-0 m-0"
                                    formControlName="tipoPersona" [required]="true"
                                    optionLabel="nombre" [showClear]="true"
                                    (onClear)="onClearTipoPersona($event)"
                                    (onChange)="onChangeTipoPersona($event)"
                                    placeholder="Tipo de Persona">
                        </p-dropdown>
                    </div>
                    <div class="field" *ngIf="!isNit() && this.typeAssign!==1">
                        <label for="tipoUsuario">Tipo de usuario <small style="color:red"><b>
                            *</b></small></label>
                        <p-dropdown id="tipoUsuario"
                                    showError
                                    pAutoFocus
                                    [options]="tiposUsuario"
                                    formControlName="tipoUsuario" [required]="true"
                                    optionLabel="nombre" [showClear]="true"
                                    placeholder="Tipo de usuario">
                        </p-dropdown>
                    </div>
                    <div class="field">
                        <label for="tipoDocumento">Tipo de documento <small style="color:red"><b> *</b></small></label>
                        <p-dropdown id="tipoDocumento"
                                    showError
                                    [options]="tiposDocumento"
                                    formControlName="tipoDocumento"
                                    [required]="true"
                                    optionLabel="nombre" [showClear]="true"
                                    (onChange)="onChangeTipoDocumento($event)"
                                    placeholder="Tipo de documento"></p-dropdown>
                    </div>
                    <div class="field">
                        <label for="numeroDocumento">Documento <small style="color:red"><b>
                            *</b></small></label>
                        <p-inputMask
                            id="numeroDocumento"
                            formControlName="numeroDocumento"
                            [pTooltip]="numDocTooltip"
                            tooltipPosition="right"
                            [fitContent]="true"
                            mask="{{this.formRegistro.get('tipoDocumento')!.value?.mascara}}"
                            placeholder="{{this.formRegistro.get('tipoDocumento')!.value?.placeholder}}"
                            required/>

                        <ng-template #numDocTooltip>
                            <p>
                                {{ this.formRegistro.get('tipoDocumento')!.value?.placeholder }}
                            </p>
                        </ng-template>
                    </div>
                    <div class="field">
                        <label for="_nombres" *ngIf="!isNit()">Nombres <small style="color:red"><b>
                            *</b></small></label>
                        <input id="_nombres" *ngIf="!isNit()" placeholder="Nombres" pInputText
                               formControlName="nombres"/>
                        <label for="_razonSocial" *ngIf="isNit()">Razón Social / Denominación</label>
                        <textarea id="_razonSocial" *ngIf="isNit()"
                                  rows="3"
                                  cols="40"
                                  pInputTextarea
                                  placeholder="Razón Social / Denominación"
                                  formControlName="nombres">
                                </textarea>
                    </div>
                    <div class="field" *ngIf="!isNit()">
                        <label for="_apellidos">Apellidos <small style="color:red"><b> *</b></small></label>
                        <input id="_apellidos" placeholder="Apellidos" pInputText formControlName="apellidos"/>
                    </div>
                    <div class="mb-3 mt-4 text-base">
                          <span class="flex align-items-center gap-2 w-full">
                                <span class="font-bold white-space-nowrap">
                                    Contactos <i class="pi pi-tag ml-auto mr-2"></i>
                                </span>
                            </span>
                    </div>
                    <ng-container>
                        <div class="field">
                            <label for="correo">Correo Electronico <small style="color:red"><b>
                                *</b></small></label>
                            <input id="correo" formControlName="correo" placeholder="Correo" pInputText
                                   type="email"/>
                        </div>
                        <div class="field">
                            <label for="telefonoUsuario">Teléfono<small style="color:red"><b> *</b></small></label>
                            <p-inputMask id="telefonoUsuario" mask="(999) 9999-9999" formControlName="celular"
                                         [required]="true"
                                         placeholder="####-####"></p-inputMask>
                        </div>
                    </ng-container>
            </p-accordion>
        </form>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
                (click)="closeDialogUser()"></button>
        <button pButton pRipple type="submit" [label]="estadoAccionUsuario?'Guardar':'Guardar cambios'"
                icon="pi pi-check" class="p-button-text"
                (click)="onConfirmSubmit()" [loading]="loading!" [disabled]="!formRegistro.valid"></button>
    </ng-template>
</p-dialog>
